import AppBar from '@mui/material/AppBar';
import logo from '@assets/logo_light_bg.svg';

import { Notifications, PatientSearchBar, ProfileMenu } from './components';
import { Box, Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Bridget } from '@views/pages/Bridget';
import { useHeader } from './hooks';
import { MultiColorLinearProgress } from '../MultiColorLinearProgress';
import { MinutesProgressTooltip } from './components/MinutesProgressTooltip.tsx';
import { EXPECTED_DAILY_USER_MINUTES } from '@common/types/constants.ts';

function Header() {
  const { careNoteValue, activityLogValue } = useHeader();

  return (
    <AppBar
      position='static'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        paddingInline: '1.5rem',
        paddingBlock: '0.75rem',
        boxShadow: 'none',
        borderBottom: theme => `1px solid ${theme.palette.grey[300]}`,
        height: '5rem',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Link to='/'>
          <Box
            component='img'
            src={logo}
            sx={{ height: '2.5rem', cursor: 'pointer' }}
          />
        </Link>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          marginX: 4,
          alignItems: 'center',
        }}
      >
        <PatientSearchBar />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Bridget />
        <Box
          sx={{
            minWidth: '134px',
            cursor: 'pointer',
            width: 'fit-content',
          }}
        >
          <Tooltip
            title={
              <MinutesProgressTooltip
                activityLogMinutes={activityLogValue}
                careNoteMinutes={careNoteValue}
              />
            }
            slotProps={{
              tooltip: {
                style: {
                  padding: '0',
                },
              },
            }}
          >
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  color: theme => theme.palette.common.black,
                  gap: 1,
                }}
              >
                <Typography variant='subtitle2'>
                  {`${careNoteValue + activityLogValue} of 
                  ${EXPECTED_DAILY_USER_MINUTES}`}
                </Typography>
                <Typography variant='caption'>minutes</Typography>
              </Box>
              <MultiColorLinearProgress
                value1={careNoteValue}
                value2={activityLogValue}
                maxValue={EXPECTED_DAILY_USER_MINUTES}
              />
            </Box>
          </Tooltip>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Notifications />
          <Box
            sx={{
              width: '1px',
              height: '44px',
              bgcolor: theme => theme.palette.grey[300],
            }}
          />
          <ProfileMenu />
        </Box>
      </Box>
    </AppBar>
  );
}

export default Header;
